import React from 'react';
import moment from 'moment';

export default () => {

  const Year = moment().format('YYYY');

  return (
    <div className="Copyright">
      <div>Adenzo Comfies&nbsp;&nbsp;</div>
      <div>{Year}&nbsp;&nbsp;|&nbsp;&nbsp;All Rights Reserved</div>
    </div>
  );

}
